import { Subject } from 'rxjs'

import {Utils} from './Utils'
/**
 * Settings that are stored in the local storage,
 * available settings can be found in Settings.Param
 * @type {Settings}
 */
export namespace Settings {
    export var buyInSettings : any
    export namespace Param {
        export const SOUND_ENABLED :string =  'sound.enabled'
        export const SOUND_ALERTS_ENABLED = 'sound.alerts.enabled'
        export const SWIPE_ENABLED = 'settings.swipe'
        export const FREEZE_COMMUNICATION = 'swttings.freeze'
        export const FOUR_COLOR_DECK_ENABLED = '4cdeck.enabled'
        export const MUCK_LOSING_HAND = 'muck.losing.hand'
        export const DONT_SHOW_WINNING_HAND = 'dont.show.winning.hand'
        export const EXTERNAL_TABLE_VIEW_ENABLED = 'external.table.view.enabled'
        export const HIDE_EXTERNAL_TABLE_TIP = 'external.table.tip'
        export const AUTO_BUY_IN_ENABLED = 'auto.buyin.enabled'
        export const MATCHING_ENABLED = 'matching.enabled'
        export const AUTO_BUY_IN_FALL_UNDER = 'auto.buyin.fall.under'
        export const AUTO_BUY_IN_WHEN_TYPE = 'auto.buyin.when.type'
        export const AUTO_BUY_IN_AMOUNT = 'auto.buyin.amount'
        export const SELECTED_THEME = 'selected.theme'
        export const AVATARS_ENABLED = 'avatars.enabled'
        export const MUTE_SPECTATORS = 'mute.spectators'
        export const MUTE_EMOTICONS = 'mute.emoticons'
        export const FILTER_BUY_IN_MICRO_ENABLED = 'filter.buyin.micro'
        export const FILTER_BUY_IN_LOW_ENABLED = 'filter.buyin.low'
        export const FILTER_BUY_IN_MEDIUM_ENABLED = 'filter.buyin.medium'
        export const FILTER_BUY_IN_HIGH_ENABLED = 'filter.buyin.high'
        export const FILTER_FORMAT_HOLDEM_ENABLED = 'filter.format.holdem'
        export const FILTER_FORMAT_OMAHA_ENABLED = 'filter.format.omaha'
        export const FILTER_FORMAT_PINEAPPLE_ENABLED = 'filter.format.pineapple'
        export const FILTER_FORMAT_OMAHA_HL_ENABLED = 'filter.format.omahahl'
        export const FILTER_LIMITS_NONE_ENABLED = 'filter.limits.none'
        export const FILTER_LIMITS_POT_ENABLED = 'filter.limits.pot'
        export const FILTER_LIMITS_FIXED_ENABLED = 'filter.limits.fixed'
        export const FILTER_TT_REGULAR_ENABLED = 'filter.tt.regular'
        export const FILTER_TT_GUARANTEED_ENABLED = 'filter.tt.guaranteed'
        export const FILTER_TT_SATELLITE_ENABLED = 'filter.tt.satellite'
        export const FILTER_TT_REBUY_ENABLED = 'filter.tt.rebuy'
        export const FILTER_TT_BOUNTY_ENABLED = 'filter.tt.bounty'
        export const FILTER_MISC_FULL_TABLES = 'filter.misc.fulltables'
        export const FILTER_MISC_REGISTERING_ONLY = 'filter.misc.registeringonly'
        export const CURRENCY_SELECTED = 'currency.selected'
        export const FILTER_MISC_GAME_TYPE = 'filter.misc.gametype'
        export const FILTER_MISC_REBUY_ENABLED = 'filter.misc.rebuyenabled'
        export const PROMO_ONLY_PHASE_1_MODAL_SHOWN = 'promo.only.phase.1.modal.shown'
        export const PROMO_ONLY_PHASE_2_MODAL_SHOWN = 'promo.only.phase.2.modal.shown'
        export const PROMO_ONLY_PHASE_3_MODAL_SHOWN = 'promo.only.phase.3.modal.shown'
    }
    /**
     * Check whether a boolean property is set to true
     * @param param
     * @param [def]
     * @return {Boolean}settings
     */
    export function isEnabled(param,def?): boolean {
    	if (!def || def==null) {
    		def = false
    	}
    	return Utils.loadBoolean(param,def)
    }
    export function getIntValue(param, def): number {

    	let val = Utils.load(param,null)
    	if (val==null) {
    		return def
    	}
    	return parseInt(val)
    }
    export function getStringValue(param,def): string {
    	let val = Utils.load(param,null)
    	if (val==null) {
    		return def
    	}
    	return val
    }

    export const settingChanged$ = new Subject<{name: string, value: string}>()
    /**
     * stores a property in the local storage
     * @param prop
     * @param value
     */
    export function setProperty(prop,value) {
    	Utils.store(prop,value)
    	settingChanged$.next({ name: prop, value })
    }
}
